module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/5@2x_d4d95194ee2920a3c27f52331fa00060.png";